const NATURE_PIECE_ORIGINE = {
	// Si on est sur un mandat
	MANDAT: {
		MANDAT: {
			CODE: '01',
			LABEL: 'Mandat',
		},
		TITRE: {
			CODE: '02',
			LABEL: 'Titre',
		},
		PAIEMENT: {
			CODE: '03',
			LABEL: 'Paiement',
		},
		LISTE_NON_VALEUR: {
			CODE: '04',
			LABEL: 'Liste en non valeur',
		},
		ORDRE_PAIEMENT_ORDONNATEUR: {
			CODE: '05',
			LABEL: 'Ordre de paiement ordonnateur',
		},
	},
	// Si on est sur un titre
	TITRE: {
		TITRE: {
			CODE: '01',
			LABEL: 'Titre',
		},
		MANDAT: {
			CODE: '02',
			LABEL: 'Mandat',
		},
		ENCAISSEMENT: {
			CODE: '03',
			LABEL: 'Encaissement',
		},
		LISTE_MAJORATION: {
			CODE: '05',
			LABEL: 'Liste de majoration',
		},
	},
} as const;

export default NATURE_PIECE_ORIGINE;
